import type { AxiosInstance } from 'axios';
import type { TAutocompleteOption } from '~/components/AutocompleteField/types.ts';
import type { TKved } from '~/queries/types.ts';

const KVED_PAGE_SIZE = 20;

export type TKvedPage = {
  content: TKved[];
  totalPages: number;
  totalElements: number;
  number: number;
  size: number;
  last: boolean;
};

export const getKvedPage = async (api: AxiosInstance, search: string): Promise<TKvedPage> => {
  const { data } = await api.get<TKvedPage>('/dictionary-service/kved/pageable', {
    params: {
      search,
      page: 0,
      size: KVED_PAGE_SIZE,
    },
  });

  return data;
};

export const mapKvedsToAutocompleteOptions = (kveds: TKved[]): TAutocompleteOption[] =>
  kveds.map(({ code }) => ({ label: code, value: code }));

export const findKvedByOption = (
  kveds: TKved[],
  option: TAutocompleteOption | null
): TKved | undefined => kveds.find(({ code }) => code === option?.value);
